import { render, staticRenderFns } from "./CustomerLevelRuleList.vue?vue&type=template&id=20c951de&scoped=true&"
import script from "./CustomerLevelRuleList.vue?vue&type=script&lang=js&"
export * from "./CustomerLevelRuleList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLevelRuleList.vue?vue&type=style&index=0&id=20c951de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c951de",
  null
  
)

export default component.exports